import { apiConfig } from "../config/apiConfig";
import { REGEX } from "../constants/regex";
import { startLoader, stopLoader } from "../util/loader";
import { getBrandJSON } from "../util/locationBasedBrandJson";
import { getFranchiseDetails, storeBookingApiPayload } from "../util/share";
import { handleMissingData } from "../util/discovery";
import { bookingUsPostCallWrapper } from "../apiCaching/POST-Requests/apibookingCallWrapper";
import { BookingPayloadModel } from "../apiCaching/POST-Requests/interface/booking/bookingInterface";
import { DomainIdentifier } from "../util/domainService";
import { getCountryCode } from "../location-search-map/getCountryCode";
import { hideTermsPolicy, toggleTermsPolicyBasedOnCountry } from "../util/hideTermsPolicy";
import { DisclaimerServiceIdentifier } from "../util/disclaimerService";
import { ContactUsPayloadModel } from "../apiCaching/POST-Requests/interface/contact/contactInterface";
import { contactUsPostCallWrapper } from "../apiCaching/POST-Requests/apiContactCallWrapper";
import { apiCaching } from "../config/cachingConfig";
import { getCachedAPIResponse } from "../apiCaching/apiWrapper";
import { attachClearFieldListeners, handleCheckboxChangeUtility, handleHideError, handleOptinEmailCheck } from "../apiCaching/POST-Requests/helperModules/handleBookingSubmit";

export class FormHandlerAskQuestionWhitePaper {
    private static instance: FormHandlerAskQuestionWhitePaper;

    private form: HTMLFormElement | null = null;
    private mobileNumberInput: HTMLInputElement | null = null;

    private nameInput: HTMLInputElement;
    private nameInput2: HTMLInputElement;
    private phoneNumberInput: HTMLInputElement;
    private emailInput: HTMLInputElement;
    private zipCodeInput: HTMLInputElement;
    private readonly privateSuggestedArray = [];
    private readonly downloadFormService: NodeListOf<HTMLElement>;

    /**
     * Get the singleton instance of FormHandlerAskQuestionWhitePaper
     * @returns {FormHandlerAskQuestionWhitePaper} The singleton instance
     */
    static getInstance(): FormHandlerAskQuestionWhitePaper {
        if (!FormHandlerAskQuestionWhitePaper.instance) {
            FormHandlerAskQuestionWhitePaper.instance = new FormHandlerAskQuestionWhitePaper();
        }
        return FormHandlerAskQuestionWhitePaper.instance;
    }

    /**
     * Helper to show or update a field error message for a given input.
     */
    private showFieldError(field: HTMLInputElement, errorMessage: string) {
        const errorId = `${field.id}-error-msg`;
        let fieldError = document.getElementById(errorId);
        if (fieldError) {
            fieldError.classList.remove('hidden');
            fieldError.innerHTML = errorMessage;
        } else if (field?.parentNode) {
            const errorElement = document.createElement('span');
            errorElement.className = 'error-msg';
            errorElement.id = errorId;
            errorElement.textContent = errorMessage;
            field.classList.add('invalid-field');
            field.parentNode.appendChild(errorElement);
        }
    }

    private constructor() {
        this.downloadFormService = document.querySelectorAll('[id*="papers-download-service-reminder"]');

        this.init();
        this.clearFields();

        this.nameInput2 = document.getElementById('lname') as HTMLInputElement;
        this.nameInput = document.getElementById('fname') as HTMLInputElement;
        this.phoneNumberInput = document.getElementById('phone-number') as HTMLInputElement;
        this.emailInput = document.getElementById('email') as HTMLInputElement;
        this.zipCodeInput = document.getElementById('zipcode') as HTMLInputElement;

        this.nameInput?.addEventListener('input', this.errorOnName.bind(this))
        this.nameInput2?.addEventListener('input', this.errorOnName2.bind(this))
        this.emailInput?.addEventListener('input', this.emailError.bind(this))
        this.zipCodeInput?.addEventListener('input', this.zipCodeError.bind(this));
        this.zipCodeInput?.addEventListener('focusout', this.handleFocusOut.bind(this));

        const backButton = document.querySelector('.thank-you-download .cta-wrapper button');
        if (backButton) {
            backButton.addEventListener('click', this.handleBackToFormClick);
        }
        this.downloadFormService?.forEach((checkbox) => {
            checkbox.addEventListener('change', this.handleCheckboxChange.bind(this));
        });
    }

    handleBackToFormClick() {
        const forms = document.getElementById('papers-download-form');
        const cont = document.getElementById('confirmation');
        if (forms) {
            forms.style.display = 'block';
            if (cont) cont.style.display = 'none';
            (document.querySelector('.thank-you-body') as HTMLElement).classList.remove('hidden');
            (document.querySelector('.error-msg-body') as HTMLElement).classList.remove('hidden');
        }
    };

    /**
     * Validates a name field and shows appropriate error if invalid
     */
    private validateNameField(input: HTMLInputElement, fieldName: string): void {
        if (input.value !== '' && !REGEX.sendName.test(input.value)) {
            this.showFieldError(input, 'Invalid name format.');
        } else {
            this.hideError(fieldName);
        }
    }

    errorOnName2() {
        this.validateNameField(this.nameInput2, 'lname');
    }

    errorOnName() {
        this.validateNameField(this.nameInput, 'fname');
    }
    emailError() {
        if (this.emailInput.value != '' && !REGEX.sendEmail.test(this.emailInput.value)) {
            this.showFieldError(this.emailInput, 'Invalid email address, please try again.');
        } else {
            this.hideError('email')
        }
    }

    private handleMobileInput(e: Event): void {
        e.preventDefault();
        const reg = REGEX.mobileNumberRegex;
        const val = this.phoneNumberInput?.value;
        const phoneMatch = val?.replace(/\D/g, '').match(reg);
        let formattedVal = '';

        if (phoneMatch) {
            const areaCode = phoneMatch[1];
            const mainNumber = phoneMatch[2];
            const optionalDashWithPhoneNumbers = phoneMatch[3] ? '-' + phoneMatch[3] : '';

            formattedVal = `(${areaCode}) ${mainNumber}${optionalDashWithPhoneNumbers}`;
        }
        if (this.phoneNumberInput.value != '' && this.phoneNumberInput?.value.length < 14 && formattedVal.length < 14) {


            this.showFieldError(this.phoneNumberInput, 'Invalid phone format.');

        }
        else {

            this.hideError.call(this, 'phone-number')
        }

        if (phoneMatch) {
            let formattedPhoneNumber;

            if (!phoneMatch[2]) {
                formattedPhoneNumber = phoneMatch[1];
            } else {
                formattedPhoneNumber = `(${phoneMatch[1]}) ${phoneMatch[2]}${phoneMatch[3] ? '-' + phoneMatch[3] : ''}`;
            }

            this.phoneNumberInput!.value = formattedPhoneNumber;
        }

    }

    zipCodeError() {
        if(!this.zipCodeInput) return;
        if (this.zipCodeInput.value != '' && !REGEX.sendZip.test(this.zipCodeInput.value.trim())) {
            this.showFieldError(this.zipCodeInput, 'Invalid zip code format.');
        }
        else {
            this.hideError('zipcode');
        }
    }


    hideError(id: any) {
        handleHideError(id);
    }

    clearFields = () => {
        attachClearFieldListeners(["send-state"]);
    };

    private init() {
        this.form = document.querySelector('#papers-download-form button') as HTMLFormElement;
        this.mobileNumberInput = document.getElementById('phone-number') as HTMLInputElement;
        const radioElement = document.getElementById('inline-radio-6') as HTMLInputElement;
        const localisation = DomainIdentifier();
        const countryCode = getCountryCode();
        const localisedcountryCode = sessionStorage.getItem('countryCode');
        if (localisation === 'ca' || countryCode === 'ca' || localisedcountryCode === 'ca') {
            hideTermsPolicy('#papers-download-form', 'terms-policy-text');
        }
        if (this.mobileNumberInput) {
            this.mobileNumberInput.addEventListener('input', this.handleMobileInput.bind(this));
        }

        if (this.form) {
            this.form.addEventListener('click', this.handleZipcodeData.bind(this));
            if (radioElement) radioElement.checked = true;
        }
    }

    private handleZipcodeData(e: any) {
        const zipCodeInput = document.getElementById('zipcode') as HTMLInputElement;
        const zipcodeData = zipCodeInput?.value.trim();
        this.getFranchiseWebLocationId(e, zipcodeData);
    }
    handleFocusOut() {
        const zipCodeInput = document.getElementById('zipcode') as HTMLInputElement;
        const zipCode = zipCodeInput?.value.trim();
        DisclaimerServiceIdentifier(zipCode);
        toggleTermsPolicyBasedOnCountry('#papers-download-form', zipCode);
    }

    handleCheckboxChange() {
        const forms = document.querySelector('#papers-download-form');
        if (!forms) {
            console.log('Form doesnt exist.');
            return;
        }
        return handleCheckboxChangeUtility("#papers-download-form")
    }

    private getFranchiseWebLocationId(event: Event, zipcodeInput: any) {
        event.preventDefault();
        const zipCode: any = zipcodeInput;
        if (this.validateForm()) {
            startLoader();
            getFranchiseDetails(zipCode, false) // Is RoundRobin is False
                .then((response: any) => {
                    const result = response;
                    if (result.length > 0) {

                        const obj = {
                            'franchiseId': result[0].franchiseId,
                            'franchiseWebLocationId': result[0].franchiseWebLocationId

                        }

                        this.handleSubmit(event, obj, zipcodeInput);
                    }
                    else {
                        this.contactUsApiCall(zipcodeInput);

                    }
                })
                .catch((error: any) => {
                    this.contactUsApiCall(zipcodeInput);
                })
        }
    }

    /**
     * Fetches brand details from the API
     */
    private async fetchBrandDetails(conceptId: string): Promise<{ vendorId: string, code: string, id: string } | null> {
        try {
            const url = window.location.origin;
            const brandJson = getBrandJSON();
            const brandjsonUrl = `${url}/${brandJson}`;
            const apiData = await getCachedAPIResponse(brandjsonUrl, apiCaching.BrandJsonConfig, false);
            return apiData.find((item: any) => item.id === conceptId) || null;
        } catch (error) {
            console.error("Error fetching brand details:", error);
            throw error;
        }
    }

    /**
     * Handles the success response after form submission
     */
    private handleFormSuccess() {
        stopLoader();
        const forms = document.getElementById('papers-download-form');
        const cont = document.getElementById('confirmation');

        if (forms) {
            forms.style.display = 'none';
            (document.querySelector('.error-msg-body') as HTMLElement)?.classList.add('hidden');
            if (cont) cont.style.display = "block";
        }

        this.downloadWhitepaper();
    }

    /**
     * Handles form submission errors
     */
    private handleFormError() {
        stopLoader();
        const forms = document.getElementById('papers-download-form');
        if (forms) {
            forms.style.display = 'none';
            (document.querySelector('.thank-you-body') as HTMLElement)?.classList.add('hidden');
            (document.querySelector('.error-msg-body') as HTMLElement)?.classList.remove('hidden');
        }

        const cont = document.getElementById('failure');
        if (cont) cont.classList.remove('hidden');

        const contCnf = document.getElementById('confirmation');
        if (contCnf) contCnf.style.display = "block";
    }

    /**
     * Initiates whitepaper download
     */
    private downloadWhitepaper() {
        const whitepaperDoc = document.getElementById('whitepaperdoc') as HTMLInputElement;
        if (!whitepaperDoc?.value) return;

        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = whitepaperDoc.value;
        a.download = 'downloaded.pdf';
        a.target = "_blank";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    /**
     * Creates a base contact payload with common fields
     */
    private createBaseContactPayload(formFields: any, brandDetails: { id: string; code: string; vendorId: string }): any {
        return {
            firstName: formFields.firstName.split(' ')[0],
            lastName: formFields.lastName.split(' ')[0],
            zipCode: formFields.zipCode.trim(),
            email: formFields.email,
            state: '',
            city: '',
            phone: formFields.phoneNumber,
            address: 'No address collected',
            address2: '',
            comments: '',
            conceptId: Number(brandDetails.id),
            conceptCode: brandDetails.code,
            vendorId: Number(brandDetails.vendorId),
            emailOptOut: false,
            signUpForUpdates: false,
            formType: this.getFormType()
        };
    }

    async contactUsApiCall(zipCode: any) {
        const formFields = this.getFormFields();
        const conceptId = (document.getElementById('conceptId') as HTMLInputElement)?.value || '11';

        try {
            const brandDetails = await this.fetchBrandDetails(conceptId);
            if (!brandDetails) throw new Error('Brand details not found');

            const franchiseWebLocationId = document.getElementById('weblocationId') as HTMLInputElement ||
                document.getElementById('local_weblocationId') as HTMLInputElement;
            const isLocalizedContact = !!(franchiseWebLocationId?.value);

            let requestBody: ContactUsPayloadModel = {
                ...this.createBaseContactPayload(formFields, brandDetails),
                isLocalized: isLocalizedContact
            };

            requestBody = this.optinEmailCheck(requestBody);
            const response = await contactUsPostCallWrapper(apiConfig.CONTACT_US_SEND, requestBody);
            storeBookingApiPayload(requestBody, response);
            this.handleFormSuccess();
        } catch (err) {
            this.handleFormError();
        }
    }

    private async handleSubmit(event: any, data: { franchiseId: any; franchiseWebLocationId: any; }, zipcodeInput: any): Promise<void> {
        event.preventDefault();
        const formFields = this.getFormFields();
        const conceptId = (document.getElementById('conceptId') as HTMLInputElement)?.value || '11';

        try {
            const brandDetails = await this.fetchBrandDetails(conceptId);
            if (!brandDetails) throw new Error('Brand details not found');

            let requestBody: BookingPayloadModel = {
                ...this.createBaseContactPayload(formFields, brandDetails),
                isLocalized: true,
                postalCode: formFields.zipCode.trim(),
                note: '',
                leadSource: "WEB",
                leadOrigin: "WEB",
                phoneType: 'true',
                isLeadOnly: true,
                scheduleID: "",
                campaignName: "N/A",
                callType: "WEB",
                conceptCalledId: Number(brandDetails.id),
                isEstimate: false,
                fileUrls: [{}],
                webLocationId: 0
            };

            if (data.franchiseWebLocationId) {
                requestBody.webLocationId = data.franchiseWebLocationId;
                requestBody.franchiseId = data.franchiseId;
            }

            const out = await handleMissingData(requestBody.city, requestBody.state, requestBody.zipCode);
            requestBody.city = out?.city || requestBody.city;
            requestBody.state = out?.state || requestBody.state;
            requestBody = this.optinEmailCheck(requestBody);

            const response = await bookingUsPostCallWrapper(apiConfig.BOOKING_API_URL, requestBody);
            storeBookingApiPayload(requestBody, response);
            this.handleFormSuccess();
        } catch (err) {
            this.handleFormError();
        }
    }

    public optinEmailCheck(requestBody: any): any {
       return handleOptinEmailCheck(
        requestBody,
        '#papers-download-form',
        'papers-download-service-reminder-us',
        'papers-download-service-reminder-ca',
        'download form'
    );
    }

    private getFormFields(): any {
        const fields = {
            firstName: (document.getElementById('fname') as HTMLInputElement).value,
            lastName: (document.getElementById('lname') as HTMLInputElement).value,
            zipCode: (document.getElementById('zipcode') as HTMLInputElement).value,
            phoneNumber: (document.getElementById('phone-number') as HTMLInputElement).value,
            email: (document.getElementById('email') as HTMLInputElement).value,
        };
        return fields;
    }

    private getSelectedRatio(node: any): string | null {
        const radioButtons = node;
        for (const radioButton of radioButtons) {
            if ((radioButton as HTMLInputElement).checked) {
                const labelElement = document.querySelector(`[for="${radioButton.id}"]`) as HTMLElement;
                const label = labelElement.innerText;
                return label;
            }
        }
        return null;
    }

    getFormType(): string{
        const caseStudyLiteral = 'case study';
        const caseStudyConstant = 'Case Study';
        const elem = document.getElementById("case-study") as HTMLInputElement | null;
        if(!elem) return '';
        if(!elem.value) return '';
        if(elem.value.toLowerCase() === caseStudyLiteral) return caseStudyConstant;
        return elem.value;
    }

    /**
     * Validates a form field against a regex pattern
     */
    private validateField(
        value: string,
        fieldName: string,
        pattern: RegExp,
        errorMessage: string,
        isRequired: boolean = true,
        customValidator?: (value: string) => boolean
    ): string | null {
        if (!value.trim()) {
            return isRequired ? '' : null;
        }

        if (!pattern.test(value) || (customValidator && !customValidator(value))) {
            return errorMessage;
        }

        return null;
    }

    private validateForm(): boolean {
        const formFields = this.getFormFields();
        document.querySelectorAll('.invalid-field').forEach((e) => e.classList.remove('invalid-field'));
        const errors: Record<string, string> = {};

        // Validate name fields
        const nameError = this.validateField(
            formFields.firstName,
            'fname',
            REGEX.sendName,
            'Invalid name format.'
        );
        if (nameError !== null) errors['fname'] = nameError;

        const lastNameError = this.validateField(
            formFields.lastName,
            'lname',
            REGEX.sendName,
            'Invalid name format.'
        );
        if (lastNameError !== null) errors['lname'] = lastNameError;

        // Validate zip code
        const zipError = this.validateField(
            formFields.zipCode,
            'zipcode',
            REGEX.sendZip,
            'Invalid zip code format.',
            true,
            (val) => val !== '00000'
        );
        if (zipError !== null) errors['zipcode'] = zipError;

        // Validate phone
        if (formFields.phoneNumber === '') {
            errors['phone-number'] = '';
        } else if (formFields.phoneNumber.length < 14) {
            errors['phone-number'] = 'Invalid phone format.';
        }

        // Validate email
        const emailError = this.validateField(
            formFields.email,
            'email',
            REGEX.sendEmail,
            'Invalid email format.'
        );
        if (emailError !== null) errors['email'] = emailError;

        // Validate other fields
        if (formFields.note === '') {
            errors['send-note'] = '';
        }

        if (formFields.city && !REGEX.sendCity.test(formFields.city)) {
            errors['send-city'] = 'Invalid city format.';
        }

        const errorIdChekboxSpan = this.handleCheckboxChange();

        if (errorIdChekboxSpan) {
            errors[errorIdChekboxSpan] = '';
        }

        Object.keys(errors).forEach((fieldId, index) => {
            const field: any = document.getElementById(fieldId);
            const fieldError: any = document.getElementById(`${fieldId}-error-msg`);
            if (field && field.parentNode) {
                const errorMessage = errors[fieldId];
                const errorElement = document.createElement('span');
                errorElement.className = 'error-msg';
                errorElement.id = `${fieldId}-error-msg`;
                errorElement.textContent = errorMessage;
                field.classList.add("invalid-field");
                // field.parentNode.appendChild(errorElement);
                if (fieldError && fieldError.classList.contains('hidden'))
                    fieldError.classList.remove('hidden')
            }
            if (index === 0 && field) {
                field.focus();
            }
        });

        return Object.keys(errors).length === 0;
    }
}
if (!(globalThis as any).__WhitePaperFormListenerAdded) {
    (globalThis as any).__WhitePaperFormListenerAdded = true;
    document.addEventListener('DOMContentLoaded', () => {
        // prevent double initialization
        if ((globalThis as any).__WhitePaperFormInitialized) return;
        const whitePaperForm = document.querySelector('#papers-download-form');
        if (whitePaperForm) {
            (globalThis as any).__WhitePaperFormInitialized = true;
            FormHandlerAskQuestionWhitePaper.getInstance();
        }
    });
}